import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import Layout from '../components/Layout/Layout';
import Hero from '../components/Screens/Hero';
import Form from '../components/Contact/Form';

// ====

const Contact = (props) => {
  const { data, blok } = props;
  let doc;
  if (data) {
    doc = JSON.parse(data.index.content);
  } else {
    doc = blok;
  }
  const openGraph = {
    type: 'website',
    title: doc.title,
    image: doc.image,
    description: doc.body,
  };

  return (
    <Layout meta={doc.meta} openGraph={openGraph}>
      <Hero
        title={doc.title}
        copy={doc.body}
        image={doc.image}
        backgroundColor={doc.background_color.color}
      />
      <section className="container">
        <div className="row justify-content-center">
          <div className="brand-col col-12 col-lg-6">
            <Form />
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;

// ====

export const QUERY = graphql`
  query ContactDefaultQuery {
    index: storyblokEntry(slug: { eq: "contact" }) {
      content
    }
  }
`;

Contact.propTypes = {
  data: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blok: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Contact.defaultProps = {
  data: null,
  blok: null,
};
